export const prefix = 'home.forms.requestNewCourse'
